export default __webpack_public_path__ + "static/media/la_ferte-vidame01.251d7eac.jpg";